"use client";

import React, { useEffect } from "react";
import ReactDOM from "react-dom";

type DrawerProps = {
  open: boolean;
  onOpenChange: (v: boolean) => void;
  children: React.ReactNode;
  ariaLabel?: string;
};

export function Drawer({
  open,
  onOpenChange,
  children,
  ariaLabel = "Navigation",
}: DrawerProps) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onOpenChange(false);
    };
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKey);
    };
  }, [open, onOpenChange]);

  if (typeof document === "undefined") return null;

  return ReactDOM.createPortal(
    <>
      <div
        aria-hidden={!open}
        onClick={() => onOpenChange(false)}
        className={`fixed inset-0 bg-black/40 transition-opacity ${open ? "opacity-100" : "opacity-0 pointer-events-none"
          }`}
      />
      <aside
        role="dialog"
        aria-label={ariaLabel}
        className={`fixed left-0 top-0 bottom-0 h-full bg-white shadow-xl transform transition-transform ${open ? "translate-x-0" : "-translate-x-full"
          }`}
        style={{ width: "min(60vw, 18rem)", zIndex: 60 }}
      >
        {children}
      </aside>
    </>,
    document.body
  );
}
